// O layout carrega o application.js com defer. Script com defer roda com o documento já em
// "interactive", e nesse estado o jQuery agenda o ready num setTimeout em vez de esperar o
// DOMContentLoaded: os callbacks de $(fn) podiam rodar entre o application.js e o script do
// controller (que ainda nem tinha rodado) ou depois dos listeners de DOMContentLoaded do Unison e
// do menu. Segurando o ready até o DOMContentLoaded, todo o código de topo dos scripts roda antes
// dos callbacks de $(fn). Carregado de forma síncrona (login, OAuth), o jQuery já espera o
// DOMContentLoaded e nada muda.
//
// No jQuery 3 o ready é sempre assíncrono: depois de liberado, os callbacks rodam num setTimeout,
// depois de todos os listeners de DOMContentLoaded (Unison, menu, Vite). O jquery.turbolinks
// continua disparando os callbacks de $(fn) juntos, na ordem em que foram registrados.
(function (window, document, jQuery) {
  if (!jQuery || document.readyState === "loading") return;

  var navigation = window.performance && window.performance.getEntriesByType && window.performance.getEntriesByType("navigation")[0];
  var contentLoaded = navigation ? navigation.domContentLoadedEventStart > 0 : document.readyState === "complete";
  if (contentLoaded) return;

  // Guarda a função agora: o jquery-migrate carrega depois e troca o jQuery.holdReady por uma
  // versão que avisa "deprecated" no console a cada página.
  var holdReady = jQuery.holdReady;

  holdReady(true);
  document.addEventListener("DOMContentLoaded", function () {
    // O setTimeout do jQuery pode ainda não ter rodado: marca o DOM como pronto aqui, e o
    // holdReady(false) libera os callbacks na hora. Se ele já rodou, só falta liberar.
    if (!jQuery.isReady) jQuery.ready();
    holdReady(false);
  });
})(window, document, window.jQuery);
